import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

function UpdateMandal() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [name, setName] = useState("");
  const [area, setArea] = useState("");
  const [description, setDescription] = useState("");
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location?.state || {};
  const currentPath = location?.pathname || "";

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "SuperAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchMandalAdminDetails = async () => {
      try {
        const config = {
          method: "get",
          url: `${apiURL}/MandalDetails/${id}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };

        const response = await axios.request(config);
        const { data } = response.data;

        setName(data.name);
        setArea(data.area);
        setDescription(data.description);
      } catch (error) {
        toast.error(error.response.data.message);
      }
    };

    if (id) {
      fetchMandalAdminDetails();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    setLoaded(true);
    e.preventDefault();

    let data = {
      id: id,
      name: name,
      area: area,
      description: description || "",
      isVisible: true,
    };
    // console.log(data);

    const config = {
      method: "post",
      url: `${apiURL}/MandalDetails/Update`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: JSON.stringify(data),
    };

    try {
      const response = await axios.request(config);
      //   console.log(response.data);
      setLoaded(false);
      toast.success(response.data.message || "Mandal Updated Successfully!");

      if (currentPath === "/update-mandal") {
        const timeOutId = setTimeout(() => {
          if (currentPath === "/update-mandal") {
            navigate("/manage-mandal", { state: { id: id } });
          }
        }, 3000);
        return () => clearTimeout(timeOutId);
      }
    } catch (error) {
      setLoaded(false);
      toast.error(error.response?.data?.message);
    }
  };

  return (
    <Layout ac8="active">
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6">
              <h5>Update Mandal</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to={"/manage"}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={"/manage-mandal"}>Mandal List</Link>
                </li>
                <li className="breadcrumb-item">Update Mandal</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="mandalName">Name</label>{" "}
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="mandalName"
                        placeholder="Enter Mandal Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="mandalDescription">Description</label>
                      <input
                        type="text"
                        className="form-control"
                        id="mandalDescription"
                        placeholder="Enter Mandal Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="mandalArea">Area</label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="mandalArea"
                        placeholder="Enter Mandal Area"
                        value={area}
                        onChange={(e) => setArea(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="float-right">
                    <button
                      type="button"
                      className="btn btn-primary mx-2"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loaded}
                    >
                      {loaded ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </>
                      ) : (
                        <>Submit</>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </Layout>
  );
}

export default UpdateMandal;
